module.exports = "<div class='main'>\n  <div class='title'>\n    {{this.topic.title}}\n    <button *ngIf='!isDeleteMode'\n      (click)='deleteAssignement()'>Delete topic assignement</button>\n    <span *ngIf='isDeleteMode'>\n       <button (click)='deleteAssignement()'>Cancel</button>\n       <button (click)='confirmDeleteAssignement()'>!!! Confirm delete !!!</button>\n     </span>\n  </div>\n  <app-note-box [dbRecord]='dbRecord'\n    [topic]='topic'></app-note-box>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/assigned-topic-box/assigned-topic-box.component.html
// module id = 417
// module chunks = 0